export default "__VITE_ASSET__FbBbGm49__"